module.exports = __webpack_public_path__ + "static/offer-podologia-image-1@2x-988d0772dbe14361e900191cb7828ef3.png";